var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.724 20.553 12 2l9.276 18.553A1 1 0 0 1 20.382 22H3.618a1 1 0 0 1-.894-1.447ZM5.236 20 12 6.472 18.764 20H5.236Zm5.55-3.114c0-.622.52-1.121 1.142-1.121.629 0 1.134.499 1.134 1.12 0 .61-.505 1.115-1.134 1.115-.622 0-1.142-.506-1.142-1.114Zm.226-5.914h1.832v3.836h-1.832v-3.836Z",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;